import axios from "axios"
import { Tenant, TenantResponse } from "@type/tenant.types"

const TENANT_PATH = "tenant"

export default class TenantService {
	static fetchTenantByName = (tenant: string) => {
		return axios.get<TenantResponse>(`${TENANT_PATH}`, {
			params: { tenant },
		})
	}

	static getAllTenants = () => {
		return axios.get<Tenant[]>(`${TENANT_PATH}/list`)
	}
}
